import RootState from '@/store/root_state';
import { ActionTree, Commit } from 'vuex';
import { MicroserviceEnum, query } from '@/helpers/westeros';
import {
  getProfileUserAccountsInfo,
  GetProfileUserAccountsInfoQueryResult,
  getTokenDInfo,
  GetTokenDInfoQueryResult,
  checkIfUserEmailExistOnAccountsResult,
  checkIfUserEmailExistOnAccountsQuery,
} from '@/store/graphql/queries/westerosArcaneumQueries';
import accounts from '@/helpers/accountsIframe';
import { UserAccountState } from './state';

const actions: ActionTree<UserAccountState, RootState> = {
  async GET_TOKEND_INFO({ commit }): Promise<void> {
    const payload = { tokenD: accounts.getTokenD() };

    const { data } = await query<GetTokenDInfoQueryResult>(
      MicroserviceEnum.ARCANEUM,
      getTokenDInfo,
      payload,
    );

    const { email } = data.getTokenDInfo;
    commit('SET_EMAIL_TOKEND', email);
  },

  async GET_PROFILE_ACCOUNT_INFO({ commit }): Promise<void> {
    const { data } = await query<GetProfileUserAccountsInfoQueryResult>(
      MicroserviceEnum.ARCANEUM,
      getProfileUserAccountsInfo,
    );

    commit('SET_PROFILE_USER_INFO', data.getProfileUserAccountsInfo);
  },

  async CHECK_EMAIL_HAS_ACCOUNTS({ commit }, payload: { email: string }): Promise<boolean> {
    const { data } = await query<checkIfUserEmailExistOnAccountsResult>(
      MicroserviceEnum.ARCANEUM,
      checkIfUserEmailExistOnAccountsQuery,
      payload,
    );
    const hasAccountLogin = !!data.checkIfUserEmailExistOnAccounts;

    commit('SET_STUDENT_EMAIL_HAS_ACCOUNTS', hasAccountLogin);

    return !!hasAccountLogin;
  },
};

export default actions;
